import * as client from '@/utils/restClient'

export const getMonthlyReserve = (year: number, month: number) => {
  const params = {
    year,
    month,
  }
  return client.post<IReserveSummary[]>(
    '/schedules/index_month_switch_json',
    params,
  )
}
